<style>
.el-tree-node__label {
  font-size: 12px;
}
</style>
<template>

  <div class="check-work-body d-flex">
    <div class="d-flex-right">
      <div>
        <div class="search-wrap">
          <el-button size="mini" @click="show_form()" type="primary">添加职业</el-button>
          <!-- <el-button size="mini" @click="" type="danger">删除</el-button> -->
        </div>
        <!-- 表格 -->
        <div class="table-wrap">
          <el-table v-if="pageData" v-loading="loading" :data="pageData.list">
            <el-table-column prop="id" label="id" align="center" width="100"></el-table-column>
            <el-table-column prop="name" label="职业名称" align="center" width=""></el-table-column>
            <el-table-column prop="social_security" label="社保基数" align="center" width=""></el-table-column>
            <el-table-column prop="housing_provident_fund" label="公积金基数" align="center" width=""></el-table-column>
            <el-table-column prop="operation" label="操作" width="200">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="show_edit_form(scope)">修改</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination-wrap">
          <el-pagination background layout="prev, pager, next" :total=pageData.total
                         :page-size="pageData.pageSize * 1" :current-page="pageData.page * 1"
                         @current-change="pageChange"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 修改窗口 -->
    <el-dialog title="编辑" z-index="990" :visible.sync="dialogVisible" :close-on-click-modal="false" width="1000px">
      <div style="max-height: 700px;overflow-y: auto;">
        <el-descriptions class="margin-top" title="" :column="2" size="mini" border>
          <el-descriptions-item label="职位名称">
            <el-input size="mini" class="form-input" v-model="form.name" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="设置社保">
            <el-input size="mini" type="number" class="form-input" v-model="form.social_security"
                      autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="设置公积金">
            <el-input size="mini" type="number" class="form-input" v-model="form.housing_provident_fund"
                      autocomplete="off"></el-input>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">关 闭</el-button>
        <el-button size="mini" @click="save_form()">确 认</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>

import Http from "./common/Http";

export default {
  name: "addressList",
  data() {
    return {
      loading: false,
      pageData: {
        list: [],
        total: 0,
        pageSize: 10,
        page: 1
      },
      dialogVisible: false,
      form: {
        id: '',
        name: '',
        social_security: '',
        housing_provident_fund: ''
      },
    }
  },
  // 获取列表
  mounted() {
    this.getPreUserList();
  },
  methods: {
    //pre职业列表
    getPreUserList(params, url) {
      Http.get(Http.getPreBaseURL() + "/oa/PreUserJob/getJobList", params, res => {
        if (res.code === 0) {
          this.pageData.list = res.data;
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },
    //分页--选中页码
    pageChange(i) {
      this.pageData.page = i;
      this.pageData.page_size = 10;
      this.handleNodeClick();
    },

    //打开添加职业表单
    show_form() {
      this.form.id = '';
      this.form.name = '';
      this.form.social_security = '';
      this.dialogVisible = true;
    },
    //打开修改表单
    show_edit_form(item) {
      this.getUserInfo(item.row.id);
      this.dialogVisible = true;
    },
    //获取职位信息
    getUserInfo(params) {
      Http.get(Http.getPreBaseURL() + "/oa/PreUserJob/getJobById", {
        id: params,
      }, res => {
        if (res.code === 0) {
          this.form = res.data;
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },
    //点击修改表单提交
    save_form() {
      Http.post(Http.getPreBaseURL() + "/oa/PreUserJob/save", this.form,
        res => {
          if (res.code === 0) {
            this.dialogVisible = false;
            this.$message({
              message: res.msg,
              type: 'success'
            });
            this.getPreUserList();
          } else {
            this.$message.error({
              message: res.msg,
              type: "error",
            });
          }
        })

    },
  }
}

</script>
<style lang="scss" scoped>
.el-button--primary,
.el-button--danger,
.el-button--success,
.el-button--warning {
  color: #fff;
}

.el-tree-node__label {
  font-size: 12px;
}

.check-work-body {
  padding: 15px;
  width: 98%;
}

.search-wrap {
  padding-bottom: 15px;
  border-bottom: 1px solid #EBEEF5;
}

.table-wrap {
  margin-top: 5px;
  //height: calc(70vh) !important;
  //overflow: auto !important;
  // background-color: aqua;
  // width: 2000rpx !important;

}

.pagination-wrap {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}


.check-work-tb {
  border-collapse: collapse;

  td,
  th {
    border: 1px solid #EBEEF5;
    line-height: 20px;
    padding: 10px 10px;
    font-size: 12px;
  }

  th {
    font-weight: bold;
    text-align: left;
  }
}

.el-calendar-table .el-calendar-day {
  height: 50px;
}

.check-work-class-editor {
  margin-top: 10px;
  width: 100%;

  .cw-header {
    width: 100%;
    display: table;
    border-collapse: collapse;

    .cw-title {
      display: table-cell;
      border: 1px solid #EBEEF5;
      padding: 5px 10px;
      line-height: 20px;
      font-weight: bold;

      &.cw-name {
        width: 100px;
      }

      &.cw-class {
        flex: 1;
      }
    }

  }

}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  //flex: 1;
}

.form-input {
  width: 100%;
}

.table-wrap {
  width: calc(100vw - 450px);
  // overflow-x: scroll;
}

.amap-box {
  width: 500px;
  height: 500px;
}

.el-tree-1 {

  overflow-y: scroll;
  height: calc(100vh - 120px);
  width: 100%;
}


.fangtai-name {
  font-size: 12px;
}

.tree-wrap {
  width: 250px;
}

.project-selector {
  margin-bottom: 10px;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Oa/PreJobManage.vue